import { Tabs } from 'antd';

import { useMagicFlowContext } from '../MagicFlowContext';
import { EventsTab } from './EventsTab';
import { FlowRunsTab } from './FlowRunsTab';
import { FlowsTab } from './FlowsTab';
import { RecipesTab } from './RecipesTab';

export const MagicFlowAdminTabs = () => {
  const { activeTab, onTabChange } = useMagicFlowContext();

  return (
    <Tabs
      className="mt-3"
      activeKey={activeTab}
      onChange={onTabChange}
      items={[
        {
          key: 'flows',
          label: 'Flows',
          children: <FlowsTab />,
        },
        {
          key: 'flow-runs',
          label: 'Flow Runs',
          children: <FlowRunsTab />,
        },
        {
          key: 'events',
          label: 'Events',
          children: <EventsTab />,
        },
        {
          key: 'recipes',
          label: 'Recipes',
          children: <RecipesTab />,
        },
      ]}
    />
  );
};
